import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";

export default function DismissChangesDialog({ isOpen, onDismiss, onOk }) {
  const { t } = useTranslation();
  return (
    <Dialog
      zIndex={200}
      type="warning"
      isOpen={isOpen}
      heading={t("dialog.discardChanges.heading")}
      text={t("dialog.discardChanges.text")}
      buttons={[
        {
          text: t("buttons.cancel"),
          onClick: onDismiss
        },
        {
          text: t("buttons.ok"),
          onClick: onOk
        }
      ]}
    />
  );
}
